import { useEffect, useState } from "react";
import { Sheet } from "@melusine/shared-ui";
import { ApiError, apiClient } from "@shared/api";

interface Tip {
  readonly id: number;
  readonly status: string;
  readonly prompt_seen: boolean;
  readonly amount_rub: string | null;
  readonly requisites_snapshot: Record<string, unknown>;
}

export function TipSheet({ orderId }: { readonly orderId: number }): JSX.Element | null {
  const [tip, setTip] = useState<Tip | null>(null);
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [proof, setProof] = useState<File | null>(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    void apiClient.get<Tip>(`/orders/${orderId}/tip/`).then((value) => {
      setTip(value);
      setOpen(!value.prompt_seen && value.status === "available");
    }).catch(() => undefined);
  }, [orderId]);

  if (tip === null || ["declined", "confirmed"].includes(tip.status)) return null;

  const action = async (value: "defer" | "decline"): Promise<void> => {
    const updated = await apiClient.post<Tip, { action: string }>(
      `/orders/${orderId}/tip/action/`, { body: { action: value } },
    );
    setTip(updated);
    setOpen(false);
  };

  const submitProof = async (): Promise<void> => {
    if (proof === null || !amount) return;
    const formData = new FormData();
    formData.append("amount_rub", amount);
    formData.append("proof_file", proof);
    try {
      const updated = await apiClient.post<Tip>(`/orders/${orderId}/tip/proof/`, { formData });
      setTip(updated);
      setMessage("Чек отправлен менеджеру на проверку.");
    } catch (error) {
      setMessage(error instanceof ApiError ? error.message : "Не удалось отправить чек.");
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)}>Оставить чаевые</button>
      <Sheet open={open} onClose={() => setOpen(false)} title="Чаевые продавцу">
        <p>Спасибо за заказ! Чаевые можно перевести по СБП.</p>
        <pre>{JSON.stringify(tip.requisites_snapshot, null, 2)}</pre>
        <input value={amount} onChange={(event) => setAmount(event.target.value)} placeholder="Сумма, ₽" />
        <input type="file" accept="image/*,.pdf" onChange={(event) => setProof(event.target.files?.[0] ?? null)} />
        <button type="button" onClick={() => void submitProof()}>Я перевёл</button>
        <button type="button" onClick={() => void action("defer")}>Не сейчас</button>
        <button type="button" onClick={() => void action("decline")}>Отказаться</button>
        {message ? <p role="status">{message}</p> : null}
      </Sheet>
    </>
  );
}
